import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { styled } from 'styled-components';

import { CheckboxGroup } from '@sorare/core/src/atoms/inputs/CheckboxGroup';
import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

import { getCompetitionPictureUrl } from 'lib/so5';

import type { CompetitionsOptions_competition } from './__generated__/index.graphql';

const CompetitionLogo = styled.img`
  width: var(--double-and-a-half-unit);
  height: var(--double-and-a-half-unit);
  object-fit: contain;
`;

type Item = {
  competition: CompetitionsOptions_competition;
  count?: number;
};

type Props = {
  competitions: Item[];
  selected: CompetitionsOptions_competition['slug'][];
  onChange: (slug: string[]) => void;
};

export const CompetitionsOptions = ({
  competitions,
  selected,
  onChange,
}: Props) => {
  const options = competitions.map(({ competition, count }) => ({
    value: competition.slug,
    label: (
      <SBHorizontal grow>
        <Horizontal>
          <CompetitionLogo src={getCompetitionPictureUrl(competition)} />
          {competition.name}
        </Horizontal>
        {!!count && <LabelS>{count}</LabelS>}
      </SBHorizontal>
    ),
  }));

  return (
    <CheckboxGroup
      options={options}
      selectedValues={selected}
      onChange={onChange}
    />
  );
};

CompetitionsOptions.fragments = {
  competition: gql`
    fragment CompetitionsOptions_competition on Competition {
      slug
      name
      ...getCompetitionPictureUrl_competition
    }
    ${getCompetitionPictureUrl.fragments.competition}
  ` as TypedDocumentNode<CompetitionsOptions_competition>,
};
